export const timezones = [
  {
    value: '(GMT-11) Pacific/Midway',
    label: '(GMT-11) Pacific/Midway',
  },
  {
    value: '(GMT-11) Pacific/Niue',
    label: '(GMT-11) Pacific/Niue',
  },
  {
    value: '(GMT-11) Pacific/Pago Pago',
    label: '(GMT-11) Pacific/Pago Pago',
  },
  {
    value: '(GMT-10) America/Adak',
    label: '(GMT-10) America/Adak',
  },
  {
    value: '(GMT-10) Pacific/Honolulu',
    label: '(GMT-10) Pacific/Honolulu',
  },
  {
    value: '(GMT-10) Pacific/Rarotonga',
    label: '(GMT-10) Pacific/Rarotonga',
  },
  {
    value: '(GMT-10) Pacific/Tahiti',
    label: '(GMT-10) Pacific/Tahiti',
  },
  {
    value: '(GMT-9.5) Pacific/Marquesas',
    label: '(GMT-9.5) Pacific/Marquesas',
  },
  {
    value: '(GMT-9) America/Anchorage',
    label: '(GMT-9) America/Anchorage',
  },
  {
    value: '(GMT-9) America/Juneau',
    label: '(GMT-9) America/Juneau',
  },
  {
    value: '(GMT-9) America/Metlakatla',
    label: '(GMT-9) America/Metlakatla',
  },
  {
    value: '(GMT-9) America/Nome',
    label: '(GMT-9) America/Nome',
  },
  {
    value: '(GMT-9) America/Sitka',
    label: '(GMT-9) America/Sitka',
  },
  {
    value: '(GMT-9) America/Yakutat',
    label: '(GMT-9) America/Yakutat',
  },
  {
    value: '(GMT-9) Pacific/Gambier',
    label: '(GMT-9) Pacific/Gambier',
  },
  {
    value: '(GMT-8) America/Los Angeles',
    label: '(GMT-8) America/Los Angeles',
  },
  {
    value: '(GMT-8) America/Tijuana',
    label: '(GMT-8) America/Tijuana',
  },
  {
    value: '(GMT-8) America/Vancouver',
    label: '(GMT-8) America/Vancouver',
  },
  {
    value: '(GMT-8) Pacific/Pitcairn',
    label: '(GMT-8) Pacific/Pitcairn',
  },
  {
    value: '(GMT-7) America/Boise',
    label: '(GMT-7) America/Boise',
  },
  {
    value: '(GMT-7) America/Cambridge Bay',
    label: '(GMT-7) America/Cambridge Bay',
  },
  {
    value: '(GMT-7) America/Creston',
    label: '(GMT-7) America/Creston',
  },
  {
    value: '(GMT-7) America/Dawson',
    label: '(GMT-7) America/Dawson',
  },
  {
    value: '(GMT-7) America/Dawson Creek',
    label: '(GMT-7) America/Dawson Creek',
  },
  {
    value: '(GMT-7) America/Denver',
    label: '(GMT-7) America/Denver',
  },
  {
    value: '(GMT-7) America/Edmonton',
    label: '(GMT-7) America/Edmonton',
  },
  {
    value: '(GMT-7) America/Fort Nelson',
    label: '(GMT-7) America/Fort Nelson',
  },
  {
    value: '(GMT-7) America/Hermosillo',
    label: '(GMT-7) America/Hermosillo',
  },
  {
    value: '(GMT-7) America/Inuvik',
    label: '(GMT-7) America/Inuvik',
  },
  {
    value: '(GMT-7) America/Mazatlan',
    label: '(GMT-7) America/Mazatlan',
  },
  {
    value: '(GMT-7) America/Phoenix',
    label: '(GMT-7) America/Phoenix',
  },
  {
    value: '(GMT-7) America/Whitehorse',
    label: '(GMT-7) America/Whitehorse',
  },
  {
    value: '(GMT-7) America/Yellowknife',
    label: '(GMT-7) America/Yellowknife',
  },
  {
    value: '(GMT-6) America/Bahia Banderas',
    label: '(GMT-6) America/Bahia Banderas',
  },
  {
    value: '(GMT-6) America/Belize',
    label: '(GMT-6) America/Belize',
  },
  {
    value: '(GMT-6) America/Chicago',
    label: '(GMT-6) America/Chicago',
  },
  {
    value: '(GMT-6) America/Chihuahua',
    label: '(GMT-6) America/Chihuahua',
  },
  {
    value: '(GMT-6) America/Costa Rica',
    label: '(GMT-6) America/Costa Rica',
  },
  {
    value: '(GMT-6) America/El Salvador',
    label: '(GMT-6) America/El Salvador',
  },
  {
    value: '(GMT-6) America/Guatemala',
    label: '(GMT-6) America/Guatemala',
  },
  {
    value: '(GMT-6) America/Indiana/Knox',
    label: '(GMT-6) America/Indiana/Knox',
  },
  {
    value: '(GMT-6) America/Indiana/Tell City',
    label: '(GMT-6) America/Indiana/Tell City',
  },
  {
    value: '(GMT-6) America/Managua',
    label: '(GMT-6) America/Managua',
  },
  {
    value: '(GMT-6) America/Matamoros',
    label: '(GMT-6) America/Matamoros',
  },
  {
    value: '(GMT-6) America/Menominee',
    label: '(GMT-6) America/Menominee',
  },
  {
    value: '(GMT-6) America/Merida',
    label: '(GMT-6) America/Merida',
  },
  {
    value: '(GMT-6) America/Mexico City',
    label: '(GMT-6) America/Mexico City',
  },
  {
    value: '(GMT-6) America/Monterrey',
    label: '(GMT-6) America/Monterrey',
  },
  {
    value: '(GMT-6) America/North Dakota/Beulah',
    label: '(GMT-6) America/North Dakota/Beulah',
  },
  {
    value: '(GMT-6) America/North Dakota/Center',
    label: '(GMT-6) America/North Dakota/Center',
  },
  {
    value: '(GMT-6) America/North Dakota/New Salem',
    label: '(GMT-6) America/North Dakota/New Salem',
  },
  {
    value: '(GMT-6) America/Ojinaga',
    label: '(GMT-6) America/Ojinaga',
  },
  {
    value: '(GMT-6) America/Rainy River',
    label: '(GMT-6) America/Rainy River',
  },
  {
    value: '(GMT-6) America/Rankin Inlet',
    label: '(GMT-6) America/Rankin Inlet',
  },
  {
    value: '(GMT-6) America/Regina',
    label: '(GMT-6) America/Regina',
  },
  {
    value: '(GMT-6) America/Resolute',
    label: '(GMT-6) America/Resolute',
  },
  {
    value: '(GMT-6) America/Swift Current',
    label: '(GMT-6) America/Swift Current',
  },
  {
    value: '(GMT-6) America/Tegucigalpa',
    label: '(GMT-6) America/Tegucigalpa',
  },
  {
    value: '(GMT-6) America/Winnipeg',
    label: '(GMT-6) America/Winnipeg',
  },
  {
    value: '(GMT-6) Pacific/Galapagos',
    label: '(GMT-6) Pacific/Galapagos',
  },
  {
    value: '(GMT-5) America/Atikokan',
    label: '(GMT-5) America/Atikokan',
  },
  {
    value: '(GMT-5) America/Bogota',
    label: '(GMT-5) America/Bogota',
  },
  {
    value: '(GMT-5) America/Cancun',
    label: '(GMT-5) America/Cancun',
  },
  {
    value: '(GMT-5) America/Cayman',
    label: '(GMT-5) America/Cayman',
  },
  {
    value: '(GMT-5) America/Detroit',
    label: '(GMT-5) America/Detroit',
  },
  {
    value: '(GMT-5) America/Eirunepe',
    label: '(GMT-5) America/Eirunepe',
  },
  {
    value: '(GMT-5) America/Grand Turk',
    label: '(GMT-5) America/Grand Turk',
  },
  {
    value: '(GMT-5) America/Guayaquil',
    label: '(GMT-5) America/Guayaquil',
  },
  {
    value: '(GMT-5) America/Havana',
    label: '(GMT-5) America/Havana',
  },
  {
    value: '(GMT-5) America/Indiana/Indianapolis',
    label: '(GMT-5) America/Indiana/Indianapolis',
  },
  {
    value: '(GMT-5) America/Indiana/Marengo',
    label: '(GMT-5) America/Indiana/Marengo',
  },
  {
    value: '(GMT-5) America/Indiana/Petersburg',
    label: '(GMT-5) America/Indiana/Petersburg',
  },
  {
    value: '(GMT-5) America/Indiana/Vevay',
    label: '(GMT-5) America/Indiana/Vevay',
  },
  {
    value: '(GMT-5) America/Indiana/Vincennes',
    label: '(GMT-5) America/Indiana/Vincennes',
  },
  {
    value: '(GMT-5) America/Indiana/Winamac',
    label: '(GMT-5) America/Indiana/Winamac',
  },
  {
    value: '(GMT-5) America/Iqaluit',
    label: '(GMT-5) America/Iqaluit',
  },
  {
    value: '(GMT-5) America/Jamaica',
    label: '(GMT-5) America/Jamaica',
  },
  {
    value: '(GMT-5) America/Kentucky/Louisville',
    label: '(GMT-5) America/Kentucky/Louisville',
  },
  {
    value: '(GMT-5) America/Kentucky/Monticello',
    label: '(GMT-5) America/Kentucky/Monticello',
  },
  {
    value: '(GMT-5) America/Lima',
    label: '(GMT-5) America/Lima',
  },
  {
    value: '(GMT-5) America/Nassau',
    label: '(GMT-5) America/Nassau',
  },
  {
    value: '(GMT-5) America/New York',
    label: '(GMT-5) America/New York',
  },
  {
    value: '(GMT-5) America/Nipigon',
    label: '(GMT-5) America/Nipigon',
  },
  {
    value: '(GMT-5) America/Panama',
    label: '(GMT-5) America/Panama',
  },
  {
    value: '(GMT-5) America/Pangnirtung',
    label: '(GMT-5) America/Pangnirtung',
  },
  {
    value: '(GMT-5) America/Port-au-Prince',
    label: '(GMT-5) America/Port-au-Prince',
  },
  {
    value: '(GMT-5) America/Rio Branco',
    label: '(GMT-5) America/Rio Branco',
  },
  {
    value: '(GMT-5) America/Thunder Bay',
    label: '(GMT-5) America/Thunder Bay',
  },
  {
    value: '(GMT-5) America/Toronto',
    label: '(GMT-5) America/Toronto',
  },
  {
    value: '(GMT-5) Pacific/Easter',
    label: '(GMT-5) Pacific/Easter',
  },
  {
    value: '(GMT-4) America/Anguilla',
    label: '(GMT-4) America/Anguilla',
  },
  {
    value: '(GMT-4) America/Antigua',
    label: '(GMT-4) America/Antigua',
  },
  {
    value: '(GMT-4) America/Aruba',
    label: '(GMT-4) America/Aruba',
  },
  {
    value: '(GMT-4) America/Barbados',
    label: '(GMT-4) America/Barbados',
  },
  {
    value: '(GMT-4) America/Blanc-Sablon',
    label: '(GMT-4) America/Blanc-Sablon',
  },
  {
    value: '(GMT-4) America/Boa Vista',
    label: '(GMT-4) America/Boa Vista',
  },
  {
    value: '(GMT-4) America/Campo Grande',
    label: '(GMT-4) America/Campo Grande',
  },
  {
    value: '(GMT-4) America/Caracas',
    label: '(GMT-4) America/Caracas',
  },
  {
    value: '(GMT-4) America/Cuiaba',
    label: '(GMT-4) America/Cuiaba',
  },
  {
    value: '(GMT-4) America/Curacao',
    label: '(GMT-4) America/Curacao',
  },
  {
    value: '(GMT-4) America/Dominica',
    label: '(GMT-4) America/Dominica',
  },
  {
    value: '(GMT-4) America/Glace Bay',
    label: '(GMT-4) America/Glace Bay',
  },
  {
    value: '(GMT-4) America/Goose Bay',
    label: '(GMT-4) America/Goose Bay',
  },
  {
    value: '(GMT-4) America/Grenada',
    label: '(GMT-4) America/Grenada',
  },
  {
    value: '(GMT-4) America/Guadeloupe',
    label: '(GMT-4) America/Guadeloupe',
  },
  {
    value: '(GMT-4) America/Guyana',
    label: '(GMT-4) America/Guyana',
  },
  {
    value: '(GMT-4) America/Halifax',
    label: '(GMT-4) America/Halifax',
  },
  {
    value: '(GMT-4) America/Kralendijk',
    label: '(GMT-4) America/Kralendijk',
  },
  {
    value: '(GMT-4) America/La Paz',
    label: '(GMT-4) America/La Paz',
  },
  {
    value: '(GMT-4) America/Lower Princes',
    label: '(GMT-4) America/Lower Princes',
  },
  {
    value: '(GMT-4) America/Manaus',
    label: '(GMT-4) America/Manaus',
  },
  {
    value: '(GMT-4) America/Marigot',
    label: '(GMT-4) America/Marigot',
  },
  {
    value: '(GMT-4) America/Martinique',
    label: '(GMT-4) America/Martinique',
  },
  {
    value: '(GMT-4) America/Moncton',
    label: '(GMT-4) America/Moncton',
  },
  {
    value: '(GMT-4) America/Montserrat',
    label: '(GMT-4) America/Montserrat',
  },
  {
    value: '(GMT-4) America/Port of Spain',
    label: '(GMT-4) America/Port of Spain',
  },
  {
    value: '(GMT-4) America/Porto Velho',
    label: '(GMT-4) America/Porto Velho',
  },
  {
    value: '(GMT-4) America/Puerto Rico',
    label: '(GMT-4) America/Puerto Rico',
  },
  {
    value: '(GMT-4) America/Santo Domingo',
    label: '(GMT-4) America/Santo Domingo',
  },
  {
    value: '(GMT-4) America/St Barthelemy',
    label: '(GMT-4) America/St Barthelemy',
  },
  {
    value: '(GMT-4) America/St Kitts',
    label: '(GMT-4) America/St Kitts',
  },
  {
    value: '(GMT-4) America/St Lucia',
    label: '(GMT-4) America/St Lucia',
  },
  {
    value: '(GMT-4) America/St Thomas',
    label: '(GMT-4) America/St Thomas',
  },
  {
    value: '(GMT-4) America/St Vincent',
    label: '(GMT-4) America/St Vincent',
  },
  {
    value: '(GMT-4) America/Thule',
    label: '(GMT-4) America/Thule',
  },
  {
    value: '(GMT-4) America/Tortola',
    label: '(GMT-4) America/Tortola',
  },
  {
    value: '(GMT-4) Atlantic/Bermuda',
    label: '(GMT-4) Atlantic/Bermuda',
  },
  {
    value: '(GMT-3.5) America/St Johns',
    label: '(GMT-3.5) America/St Johns',
  },
  {
    value: '(GMT-3) America/Araguaina',
    label: '(GMT-3) America/Araguaina',
  },
  {
    value: '(GMT-3) America/Argentina/Buenos Aires',
    label: '(GMT-3) America/Argentina/Buenos Aires',
  },
  {
    value: '(GMT-3) America/Argentina/Catamarca',
    label: '(GMT-3) America/Argentina/Catamarca',
  },
  {
    value: '(GMT-3) America/Argentina/Cordoba',
    label: '(GMT-3) America/Argentina/Cordoba',
  },
  {
    value: '(GMT-3) America/Argentina/Jujuy',
    label: '(GMT-3) America/Argentina/Jujuy',
  },
  {
    value: '(GMT-3) America/Argentina/La Rioja',
    label: '(GMT-3) America/Argentina/La Rioja',
  },
  {
    value: '(GMT-3) America/Argentina/Mendoza',
    label: '(GMT-3) America/Argentina/Mendoza',
  },
  {
    value: '(GMT-3) America/Argentina/Rio Gallegos',
    label: '(GMT-3) America/Argentina/Rio Gallegos',
  },
  {
    value: '(GMT-3) America/Argentina/Salta',
    label: '(GMT-3) America/Argentina/Salta',
  },
  {
    value: '(GMT-3) America/Argentina/San Juan',
    label: '(GMT-3) America/Argentina/San Juan',
  },
  {
    value: '(GMT-3) America/Argentina/San Luis',
    label: '(GMT-3) America/Argentina/San Luis',
  },
  {
    value: '(GMT-3) America/Argentina/Tucuman',
    label: '(GMT-3) America/Argentina/Tucuman',
  },
  {
    value: '(GMT-3) America/Argentina/Ushuaia',
    label: '(GMT-3) America/Argentina/Ushuaia',
  },
  {
    value: '(GMT-3) America/Asuncion',
    label: '(GMT-3) America/Asuncion',
  },
  {
    value: '(GMT-3) America/Bahia',
    label: '(GMT-3) America/Bahia',
  },
  {
    value: '(GMT-3) America/Belem',
    label: '(GMT-3) America/Belem',
  },
  {
    value: '(GMT-3) America/Cayenne',
    label: '(GMT-3) America/Cayenne',
  },
  {
    value: '(GMT-3) America/Fortaleza',
    label: '(GMT-3) America/Fortaleza',
  },
  {
    value: '(GMT-3) America/Maceio',
    label: '(GMT-3) America/Maceio',
  },
  {
    value: '(GMT-3) America/Miquelon',
    label: '(GMT-3) America/Miquelon',
  },
  {
    value: '(GMT-3) America/Montevideo',
    label: '(GMT-3) America/Montevideo',
  },
  {
    value: '(GMT-3) America/Paramaribo',
    label: '(GMT-3) America/Paramaribo',
  },
  {
    value: '(GMT-3) America/Punta Arenas',
    label: '(GMT-3) America/Punta Arenas',
  },
  {
    value: '(GMT-3) America/Recife',
    label: '(GMT-3) America/Recife',
  },
  {
    value: '(GMT-3) America/Santarem',
    label: '(GMT-3) America/Santarem',
  },
  {
    value: '(GMT-3) America/Santiago',
    label: '(GMT-3) America/Santiago',
  },
  {
    value: '(GMT-3) America/Sao Paulo',
    label: '(GMT-3) America/Sao Paulo',
  },
  {
    value: '(GMT-3) Antarctica/Palmer',
    label: '(GMT-3) Antarctica/Palmer',
  },
  {
    value: '(GMT-3) Antarctica/Rothera',
    label: '(GMT-3) Antarctica/Rothera',
  },
  {
    value: '(GMT-3) Atlantic/Stanley',
    label: '(GMT-3) Atlantic/Stanley',
  },
  {
    value: '(GMT-2) America/Noronha',
    label: '(GMT-2) America/Noronha',
  },
  {
    value: '(GMT-2) America/Nuuk',
    label: '(GMT-2) America/Nuuk',
  },
  {
    value: '(GMT-2) America/Scoresbysund',
    label: '(GMT-2) America/Scoresbysund',
  },
  {
    value: '(GMT-2) Atlantic/South Georgia',
    label: '(GMT-2) Atlantic/South Georgia',
  },
  {
    value: '(GMT-1) Atlantic/Azores',
    label: '(GMT-1) Atlantic/Azores',
  },
  {
    value: '(GMT-1) Atlantic/Cape Verde',
    label: '(GMT-1) Atlantic/Cape Verde',
  },
  {
    value: '(GMT+0) Africa/Abidjan',
    label: '(GMT+0) Africa/Abidjan',
  },
  {
    value: '(GMT+0) Africa/Accra',
    label: '(GMT+0) Africa/Accra',
  },
  {
    value: '(GMT+0) Africa/Bamako',
    label: '(GMT+0) Africa/Bamako',
  },
  {
    value: '(GMT+0) Africa/Banjul',
    label: '(GMT+0) Africa/Banjul',
  },
  {
    value: '(GMT+0) Africa/Bissau',
    label: '(GMT+0) Africa/Bissau',
  },
  {
    value: '(GMT+0) Africa/Conakry',
    label: '(GMT+0) Africa/Conakry',
  },
  {
    value: '(GMT+0) Africa/Dakar',
    label: '(GMT+0) Africa/Dakar',
  },
  {
    value: '(GMT+0) Africa/Freetown',
    label: '(GMT+0) Africa/Freetown',
  },
  {
    value: '(GMT+0) Africa/Lome',
    label: '(GMT+0) Africa/Lome',
  },
  {
    value: '(GMT+0) Africa/Monrovia',
    label: '(GMT+0) Africa/Monrovia',
  },
  {
    value: '(GMT+0) Africa/Nouakchott',
    label: '(GMT+0) Africa/Nouakchott',
  },
  {
    value: '(GMT+0) Africa/Ouagadougou',
    label: '(GMT+0) Africa/Ouagadougou',
  },
  {
    value: '(GMT+0) Africa/Sao Tome',
    label: '(GMT+0) Africa/Sao Tome',
  },
  {
    value: '(GMT+0) America/Danmarkshavn',
    label: '(GMT+0) America/Danmarkshavn',
  },
  {
    value: '(GMT+0) Antarctica/Troll',
    label: '(GMT+0) Antarctica/Troll',
  },
  {
    value: '(GMT+0) Atlantic/Canary',
    label: '(GMT+0) Atlantic/Canary',
  },
  {
    value: '(GMT+0) Atlantic/Faroe',
    label: '(GMT+0) Atlantic/Faroe',
  },
  {
    value: '(GMT+0) Atlantic/Madeira',
    label: '(GMT+0) Atlantic/Madeira',
  },
  {
    value: '(GMT+0) Atlantic/Reykjavik',
    label: '(GMT+0) Atlantic/Reykjavik',
  },
  {
    value: '(GMT+0) Atlantic/St Helena',
    label: '(GMT+0) Atlantic/St Helena',
  },
  {
    value: '(GMT+0) Europe/Dublin',
    label: '(GMT+0) Europe/Dublin',
  },
  {
    value: '(GMT+0) Europe/Guernsey',
    label: '(GMT+0) Europe/Guernsey',
  },
  {
    value: '(GMT+0) Europe/Isle of Man',
    label: '(GMT+0) Europe/Isle of Man',
  },
  {
    value: '(GMT+0) Europe/Jersey',
    label: '(GMT+0) Europe/Jersey',
  },
  {
    value: '(GMT+0) Europe/Lisbon',
    label: '(GMT+0) Europe/Lisbon',
  },
  {
    value: '(GMT+1) Africa/Algiers',
    label: '(GMT+1) Africa/Algiers',
  },
  {
    value: '(GMT+1) Africa/Bangui',
    label: '(GMT+1) Africa/Bangui',
  },
  {
    value: '(GMT+1) Africa/Brazzaville',
    label: '(GMT+1) Africa/Brazzaville',
  },
  {
    value: '(GMT+1) Africa/Casablanca',
    label: '(GMT+1) Africa/Casablanca',
  },
  {
    value: '(GMT+1) Africa/Ceuta',
    label: '(GMT+1) Africa/Ceuta',
  },
  {
    value: '(GMT+1) Africa/Douala',
    label: '(GMT+1) Africa/Douala',
  },
  {
    value: '(GMT+1) Africa/El Aaiun',
    label: '(GMT+1) Africa/El Aaiun',
  },
  {
    value: '(GMT+1) Africa/Kinshasa',
    label: '(GMT+1) Africa/Kinshasa',
  },
  {
    value: '(GMT+1) Africa/Lagos',
    label: '(GMT+1) Africa/Lagos',
  },
  {
    value: '(GMT+1) Africa/Libreville',
    label: '(GMT+1) Africa/Libreville',
  },
  {
    value: '(GMT+1) Africa/Luanda',
    label: '(GMT+1) Africa/Luanda',
  },
  {
    value: '(GMT+1) Africa/Malabo',
    label: '(GMT+1) Africa/Malabo',
  },
  {
    value: '(GMT+1) Africa/Ndjamena',
    label: '(GMT+1) Africa/Ndjamena',
  },
  {
    value: '(GMT+1) Africa/Niamey',
    label: '(GMT+1) Africa/Niamey',
  },
  {
    value: '(GMT+1) Africa/Porto-Novo',
    label: '(GMT+1) Africa/Porto-Novo',
  },
  {
    value: '(GMT+1) Africa/Tunis',
    label: '(GMT+1) Africa/Tunis',
  },
  {
    value: '(GMT+1) Arctic/Longyearbyen',
    label: '(GMT+1) Arctic/Longyearbyen',
  },
  {
    value: '(GMT+1) Europe/Amsterdam',
    label: '(GMT+1) Europe/Amsterdam',
  },
  {
    value: '(GMT+1) Europe/Andorra',
    label: '(GMT+1) Europe/Andorra',
  },
  {
    value: '(GMT+1) Europe/Belgrade',
    label: '(GMT+1) Europe/Belgrade',
  },
  {
    value: '(GMT+1) Europe/Berlin',
    label: '(GMT+1) Europe/Berlin',
  },
  {
    value: '(GMT+1) Europe/Bratislava',
    label: '(GMT+1) Europe/Bratislava',
  },
  {
    value: '(GMT+1) Europe/Brussels',
    label: '(GMT+1) Europe/Brussels',
  },
  {
    value: '(GMT+1) Europe/Budapest',
    label: '(GMT+1) Europe/Budapest',
  },
  {
    value: '(GMT+1) Europe/Busingen',
    label: '(GMT+1) Europe/Busingen',
  },
  {
    value: '(GMT+1) Europe/Copenhagen',
    label: '(GMT+1) Europe/Copenhagen',
  },
  {
    value: '(GMT+1) Europe/Gibraltar',
    label: '(GMT+1) Europe/Gibraltar',
  },
  {
    value: '(GMT+1) Europe/Ljubljana',
    label: '(GMT+1) Europe/Ljubljana',
  },
  {
    value: '(GMT+1) Europe/Luxembourg',
    label: '(GMT+1) Europe/Luxembourg',
  },
  {
    value: '(GMT+1) Europe/Madrid',
    label: '(GMT+1) Europe/Madrid',
  },
  {
    value: '(GMT+1) Europe/Malta',
    label: '(GMT+1) Europe/Malta',
  },
  {
    value: '(GMT+1) Europe/Monaco',
    label: '(GMT+1) Europe/Monaco',
  },
  {
    value: '(GMT+1) Europe/Oslo',
    label: '(GMT+1) Europe/Oslo',
  },
  {
    value: '(GMT+1) Europe/Paris',
    label: '(GMT+1) Europe/Paris',
  },
  {
    value: '(GMT+1) Europe/Podgorica',
    label: '(GMT+1) Europe/Podgorica',
  },
  {
    value: '(GMT+1) Europe/Prague',
    label: '(GMT+1) Europe/Prague',
  },
  {
    value: '(GMT+1) Europe/Rome',
    label: '(GMT+1) Europe/Rome',
  },
  {
    value: '(GMT+1) Europe/San Marino',
    label: '(GMT+1) Europe/San Marino',
  },
  {
    value: '(GMT+1) Europe/Sarajevo',
    label: '(GMT+1) Europe/Sarajevo',
  },
  {
    value: '(GMT+1) Europe/Skopje',
    label: '(GMT+1) Europe/Skopje',
  },
  {
    value: '(GMT+1) Europe/Stockholm',
    label: '(GMT+1) Europe/Stockholm',
  },
  {
    value: '(GMT+1) Europe/Tirane',
    label: '(GMT+1) Europe/Tirane',
  },
  {
    value: '(GMT+1) Europe/Vaduz',
    label: '(GMT+1) Europe/Vaduz',
  },
  {
    value: '(GMT+1) Europe/Vatican',
    label: '(GMT+1) Europe/Vatican',
  },
  {
    value: '(GMT+1) Europe/Vienna',
    label: '(GMT+1) Europe/Vienna',
  },
  {
    value: '(GMT+1) Europe/Warsaw',
    label: '(GMT+1) Europe/Warsaw',
  },
  {
    value: '(GMT+1) Europe/Zagreb',
    label: '(GMT+1) Europe/Zagreb',
  },
  {
    value: '(GMT+1) Europe/Zurich',
    label: '(GMT+1) Europe/Zurich',
  },
  {
    value: '(GMT+2) Africa/Blantyre',
    label: '(GMT+2) Africa/Blantyre',
  },
  {
    value: '(GMT+2) Africa/Bujumbura',
    label: '(GMT+2) Africa/Bujumbura',
  },
  {
    value: '(GMT+2) Africa/Cairo',
    label: '(GMT+2) Africa/Cairo',
  },
  {
    value: '(GMT+2) Africa/Gaborone',
    label: '(GMT+2) Africa/Gaborone',
  },
  {
    value: '(GMT+2) Africa/Harare',
    label: '(GMT+2) Africa/Harare',
  },
  {
    value: '(GMT+2) Africa/Johannesburg',
    label: '(GMT+2) Africa/Johannesburg',
  },
  {
    value: '(GMT+2) Africa/Juba',
    label: '(GMT+2) Africa/Juba',
  },
  {
    value: '(GMT+2) Africa/Khartoum',
    label: '(GMT+2) Africa/Khartoum',
  },
  {
    value: '(GMT+2) Africa/Kigali',
    label: '(GMT+2) Africa/Kigali',
  },
  {
    value: '(GMT+2) Africa/Lubumbashi',
    label: '(GMT+2) Africa/Lubumbashi',
  },
  {
    value: '(GMT+2) Africa/Lusaka',
    label: '(GMT+2) Africa/Lusaka',
  },
  {
    value: '(GMT+2) Africa/Maputo',
    label: '(GMT+2) Africa/Maputo',
  },
  {
    value: '(GMT+2) Africa/Maseru',
    label: '(GMT+2) Africa/Maseru',
  },
  {
    value: '(GMT+2) Africa/Mbabane',
    label: '(GMT+2) Africa/Mbabane',
  },
  {
    value: '(GMT+2) Africa/Tripoli',
    label: '(GMT+2) Africa/Tripoli',
  },
  {
    value: '(GMT+2) Africa/Windhoek',
    label: '(GMT+2) Africa/Windhoek',
  },
  {
    value: '(GMT+2) Asia/Beirut',
    label: '(GMT+2) Asia/Beirut',
  },
  {
    value: '(GMT+2) Asia/Famagusta',
    label: '(GMT+2) Asia/Famagusta',
  },
  {
    value: '(GMT+2) Asia/Gaza',
    label: '(GMT+2) Asia/Gaza',
  },
  {
    value: '(GMT+2) Asia/Hebron',
    label: '(GMT+2) Asia/Hebron',
  },
  {
    value: '(GMT+2) Asia/Jerusalem',
    label: '(GMT+2) Asia/Jerusalem',
  },
  {
    value: '(GMT+2) Asia/Nicosia',
    label: '(GMT+2) Asia/Nicosia',
  },
  {
    value: '(GMT+2) Europe/Athens',
    label: '(GMT+2) Europe/Athens',
  },
  {
    value: '(GMT+2) Europe/Bucharest',
    label: '(GMT+2) Europe/Bucharest',
  },
  {
    value: '(GMT+2) Europe/Chisinau',
    label: '(GMT+2) Europe/Chisinau',
  },
  {
    value: '(GMT+2) Europe/Helsinki',
    label: '(GMT+2) Europe/Helsinki',
  },
  {
    value: '(GMT+2) Europe/Kaliningrad',
    label: '(GMT+2) Europe/Kaliningrad',
  },
  {
    value: '(GMT+2) Europe/Kyiv',
    label: '(GMT+2) Europe/Kyiv',
  },
  {
    value: '(GMT+2) Europe/Mariehamn',
    label: '(GMT+2) Europe/Mariehamn',
  },
  {
    value: '(GMT+2) Europe/Riga',
    label: '(GMT+2) Europe/Riga',
  },
  {
    value: '(GMT+2) Europe/Sofia',
    label: '(GMT+2) Europe/Sofia',
  },
  {
    value: '(GMT+2) Europe/Tallinn',
    label: '(GMT+2) Europe/Tallinn',
  },
  {
    value: '(GMT+2) Europe/Uzhgorod',
    label: '(GMT+2) Europe/Uzhgorod',
  },
  {
    value: '(GMT+2) Europe/Vilnius',
    label: '(GMT+2) Europe/Vilnius',
  },
  {
    value: '(GMT+2) Europe/Zaporozhye',
    label: '(GMT+2) Europe/Zaporozhye',
  },
  {
    value: '(GMT+3) Africa/Addis Ababa',
    label: '(GMT+3) Africa/Addis Ababa',
  },
  {
    value: '(GMT+3) Africa/Asmara',
    label: '(GMT+3) Africa/Asmara',
  },
  {
    value: '(GMT+3) Africa/Dar es Salaam',
    label: '(GMT+3) Africa/Dar es Salaam',
  },
  {
    value: '(GMT+3) Africa/Djibouti',
    label: '(GMT+3) Africa/Djibouti',
  },
  {
    value: '(GMT+3) Africa/Kampala',
    label: '(GMT+3) Africa/Kampala',
  },
  {
    value: '(GMT+3) Africa/Mogadishu',
    label: '(GMT+3) Africa/Mogadishu',
  },
  {
    value: '(GMT+3) Africa/Nairobi',
    label: '(GMT+3) Africa/Nairobi',
  },
  {
    value: '(GMT+3) Antarctica/Syowa',
    label: '(GMT+3) Antarctica/Syowa',
  },
  {
    value: '(GMT+3) Asia/Aden',
    label: '(GMT+3) Asia/Aden',
  },
  {
    value: '(GMT+3) Asia/Amman',
    label: '(GMT+3) Asia/Amman',
  },
  {
    value: '(GMT+3) Asia/Baghdad',
    label: '(GMT+3) Asia/Baghdad',
  },
  {
    value: '(GMT+3) Asia/Bahrain',
    label: '(GMT+3) Asia/Bahrain',
  },
  {
    value: '(GMT+3) Asia/Damascus',
    label: '(GMT+3) Asia/Damascus',
  },
  {
    value: '(GMT+3) Asia/Kuwait',
    label: '(GMT+3) Asia/Kuwait',
  },
  {
    value: '(GMT+3) Asia/Qatar',
    label: '(GMT+3) Asia/Qatar',
  },
  {
    value: '(GMT+3) Asia/Riyadh',
    label: '(GMT+3) Asia/Riyadh',
  },
  {
    value: '(GMT+3) Europe/Istanbul',
    label: '(GMT+3) Europe/Istanbul',
  },
  {
    value: '(GMT+3) Europe/Kirov',
    label: '(GMT+3) Europe/Kirov',
  },
  {
    value: '(GMT+3) Europe/Minsk',
    label: '(GMT+3) Europe/Minsk',
  },
  {
    value: '(GMT+3) Europe/Moscow',
    label: '(GMT+3) Europe/Moscow',
  },
  {
    value: '(GMT+3) Europe/Simferopol',
    label: '(GMT+3) Europe/Simferopol',
  },
  {
    value: '(GMT+3) Europe/Volgograd',
    label: '(GMT+3) Europe/Volgograd',
  },
  {
    value: '(GMT+3) Indian/Antananarivo',
    label: '(GMT+3) Indian/Antananarivo',
  },
  {
    value: '(GMT+3) Indian/Comoro',
    label: '(GMT+3) Indian/Comoro',
  },
  {
    value: '(GMT+3) Indian/Mayotte',
    label: '(GMT+3) Indian/Mayotte',
  },
  {
    value: '(GMT+3.5) Asia/Tehran',
    label: '(GMT+3.5) Asia/Tehran',
  },
  {
    value: '(GMT+4) Asia/Baku',
    label: '(GMT+4) Asia/Baku',
  },
  {
    value: '(GMT+4) Asia/Dubai',
    label: '(GMT+4) Asia/Dubai',
  },
  {
    value: '(GMT+4) Asia/Muscat',
    label: '(GMT+4) Asia/Muscat',
  },
  {
    value: '(GMT+4) Asia/Tbilisi',
    label: '(GMT+4) Asia/Tbilisi',
  },
  {
    value: '(GMT+4) Asia/Yerevan',
    label: '(GMT+4) Asia/Yerevan',
  },
  {
    value: '(GMT+4) Europe/Astrakhan',
    label: '(GMT+4) Europe/Astrakhan',
  },
  {
    value: '(GMT+4) Europe/Samara',
    label: '(GMT+4) Europe/Samara',
  },
  {
    value: '(GMT+4) Europe/Saratov',
    label: '(GMT+4) Europe/Saratov',
  },
  {
    value: '(GMT+4) Europe/Ulyanovsk',
    label: '(GMT+4) Europe/Ulyanovsk',
  },
  {
    value: '(GMT+4) Indian/Mahe',
    label: '(GMT+4) Indian/Mahe',
  },
  {
    value: '(GMT+4) Indian/Mauritius',
    label: '(GMT+4) Indian/Mauritius',
  },
  {
    value: '(GMT+4) Indian/Reunion',
    label: '(GMT+4) Indian/Reunion',
  },
  {
    value: '(GMT+4.5) Asia/Kabul',
    label: '(GMT+4.5) Asia/Kabul',
  },
  {
    value: '(GMT+5) Antarctica/Mawson',
    label: '(GMT+5) Antarctica/Mawson',
  },
  {
    value: '(GMT+5) Antarctica/Vostok',
    label: '(GMT+5) Antarctica/Vostok',
  },
  {
    value: '(GMT+5) Asia/Almaty',
    label: '(GMT+5) Asia/Almaty',
  },
  {
    value: '(GMT+5) Asia/Aqtau',
    label: '(GMT+5) Asia/Aqtau',
  },
  {
    value: '(GMT+5) Asia/Aqtobe',
    label: '(GMT+5) Asia/Aqtobe',
  },
  {
    value: '(GMT+5) Asia/Ashgabat',
    label: '(GMT+5) Asia/Ashgabat',
  },
  {
    value: '(GMT+5) Asia/Atyrau',
    label: '(GMT+5) Asia/Atyrau',
  },
  {
    value: '(GMT+5) Asia/Dushanbe',
    label: '(GMT+5) Asia/Dushanbe',
  },
  {
    value: '(GMT+5) Asia/Karachi',
    label: '(GMT+5) Asia/Karachi',
  },
  {
    value: '(GMT+5) Asia/Oral',
    label: '(GMT+5) Asia/Oral',
  },
  {
    value: '(GMT+5) Asia/Qostanay',
    label: '(GMT+5) Asia/Qostanay',
  },
  {
    value: '(GMT+5) Asia/Qyzylorda',
    label: '(GMT+5) Asia/Qyzylorda',
  },
  {
    value: '(GMT+5) Asia/Samarkand',
    label: '(GMT+5) Asia/Samarkand',
  },
  {
    value: '(GMT+5) Asia/Tashkent',
    label: '(GMT+5) Asia/Tashkent',
  },
  {
    value: '(GMT+5) Asia/Yekaterinburg',
    label: '(GMT+5) Asia/Yekaterinburg',
  },
  {
    value: '(GMT+5) Indian/Kerguelen',
    label: '(GMT+5) Indian/Kerguelen',
  },
  {
    value: '(GMT+5) Indian/Maldives',
    label: '(GMT+5) Indian/Maldives',
  },
  {
    value: '(GMT+5.5) Asia/Colombo',
    label: '(GMT+5.5) Asia/Colombo',
  },
  {
    value: '(GMT+5.5) Asia/Kolkata',
    label: '(GMT+5.5) Asia/Kolkata',
  },
  {
    value: '(GMT+5.75) Asia/Kathmandu',
    label: '(GMT+5.75) Asia/Kathmandu',
  },
  {
    value: '(GMT+6) Asia/Bishkek',
    label: '(GMT+6) Asia/Bishkek',
  },
  {
    value: '(GMT+6) Asia/Dhaka',
    label: '(GMT+6) Asia/Dhaka',
  },
  {
    value: '(GMT+6) Asia/Omsk',
    label: '(GMT+6) Asia/Omsk',
  },
  {
    value: '(GMT+6) Asia/Thimphu',
    label: '(GMT+6) Asia/Thimphu',
  },
  {
    value: '(GMT+6) Asia/Urumqi',
    label: '(GMT+6) Asia/Urumqi',
  },
  {
    value: '(GMT+6) Indian/Chagos',
    label: '(GMT+6) Indian/Chagos',
  },
  {
    value: '(GMT+6.5) Asia/Yangon',
    label: '(GMT+6.5) Asia/Yangon',
  },
  {
    value: '(GMT+6.5) Indian/Cocos',
    label: '(GMT+6.5) Indian/Cocos',
  },
  {
    value: '(GMT+7) Antarctica/Davis',
    label: '(GMT+7) Antarctica/Davis',
  },
  {
    value: '(GMT+7) Asia/Bangkok',
    label: '(GMT+7) Asia/Bangkok',
  },
  {
    value: '(GMT+7) Asia/Barnaul',
    label: '(GMT+7) Asia/Barnaul',
  },
  {
    value: '(GMT+7) Asia/Ho Chi Minh',
    label: '(GMT+7) Asia/Ho Chi Minh',
  },
  {
    value: '(GMT+7) Asia/Hovd',
    label: '(GMT+7) Asia/Hovd',
  },
  {
    value: '(GMT+7) Asia/Jakarta',
    label: '(GMT+7) Asia/Jakarta',
  },
  {
    value: '(GMT+7) Asia/Krasnoyarsk',
    label: '(GMT+7) Asia/Krasnoyarsk',
  },
  {
    value: '(GMT+7) Asia/Novokuznetsk',
    label: '(GMT+7) Asia/Novokuznetsk',
  },
  {
    value: '(GMT+7) Asia/Novosibirsk',
    label: '(GMT+7) Asia/Novosibirsk',
  },
  {
    value: '(GMT+7) Asia/Phnom Penh',
    label: '(GMT+7) Asia/Phnom Penh',
  },
  {
    value: '(GMT+7) Asia/Pontianak',
    label: '(GMT+7) Asia/Pontianak',
  },
  {
    value: '(GMT+7) Asia/Tomsk',
    label: '(GMT+7) Asia/Tomsk',
  },
  {
    value: '(GMT+7) Asia/Vientiane',
    label: '(GMT+7) Asia/Vientiane',
  },
  {
    value: '(GMT+7) Indian/Christmas',
    label: '(GMT+7) Indian/Christmas',
  },
  {
    value: '(GMT+8) Antarctica/Casey',
    label: '(GMT+8) Antarctica/Casey',
  },
  {
    value: '(GMT+8) Asia/Brunei',
    label: '(GMT+8) Asia/Brunei',
  },
  {
    value: '(GMT+8) Asia/Choibalsan',
    label: '(GMT+8) Asia/Choibalsan',
  },
  {
    value: '(GMT+8) Asia/Hong Kong',
    label: '(GMT+8) Asia/Hong Kong',
  },
  {
    value: '(GMT+8) Asia/Irkutsk',
    label: '(GMT+8) Asia/Irkutsk',
  },
  {
    value: '(GMT+8) Asia/Kuala Lumpur',
    label: '(GMT+8) Asia/Kuala Lumpur',
  },
  {
    value: '(GMT+8) Asia/Kuching',
    label: '(GMT+8) Asia/Kuching',
  },
  {
    value: '(GMT+8) Asia/Macau',
    label: '(GMT+8) Asia/Macau',
  },
  {
    value: '(GMT+8) Asia/Makassar',
    label: '(GMT+8) Asia/Makassar',
  },
  {
    value: '(GMT+8) Asia/Manila',
    label: '(GMT+8) Asia/Manila',
  },
  {
    value: '(GMT+8) Asia/Shanghai',
    label: '(GMT+8) Asia/Shanghai',
  },
  {
    value: '(GMT+8) Asia/Singapore',
    label: '(GMT+8) Asia/Singapore',
  },
  {
    value: '(GMT+8) Asia/Taipei',
    label: '(GMT+8) Asia/Taipei',
  },
  {
    value: '(GMT+8) Asia/Ulaanbaatar',
    label: '(GMT+8) Asia/Ulaanbaatar',
  },
  {
    value: '(GMT+8) Australia/Perth',
    label: '(GMT+8) Australia/Perth',
  },
  {
    value: '(GMT+8.75) Australia/Eucla',
    label: '(GMT+8.75) Australia/Eucla',
  },
  {
    value: '(GMT+9) Asia/Chita',
    label: '(GMT+9) Asia/Chita',
  },
  {
    value: '(GMT+9) Asia/Dili',
    label: '(GMT+9) Asia/Dili',
  },
  {
    value: '(GMT+9) Asia/Jayapura',
    label: '(GMT+9) Asia/Jayapura',
  },
  {
    value: '(GMT+9) Asia/Khandyga',
    label: '(GMT+9) Asia/Khandyga',
  },
  {
    value: '(GMT+9) Asia/Pyongyang',
    label: '(GMT+9) Asia/Pyongyang',
  },
  {
    value: '(GMT+9) Asia/Seoul',
    label: '(GMT+9) Asia/Seoul',
  },
  {
    value: '(GMT+9) Asia/Tokyo',
    label: '(GMT+9) Asia/Tokyo',
  },
  {
    value: '(GMT+9) Asia/Yakutsk',
    label: '(GMT+9) Asia/Yakutsk',
  },
  {
    value: '(GMT+9) Pacific/Palau',
    label: '(GMT+9) Pacific/Palau',
  },
  {
    value: '(GMT+9.5) Australia/Darwin',
    label: '(GMT+9.5) Australia/Darwin',
  },
  {
    value: '(GMT+10) Antarctica/DumontDUrville',
    label: '(GMT+10) Antarctica/DumontDUrville',
  },
  {
    value: '(GMT+10) Asia/Ust-Nera',
    label: '(GMT+10) Asia/Ust-Nera',
  },
  {
    value: '(GMT+10) Asia/Vladivostok',
    label: '(GMT+10) Asia/Vladivostok',
  },
  {
    value: '(GMT+10) Australia/Brisbane',
    label: '(GMT+10) Australia/Brisbane',
  },
  {
    value: '(GMT+10) Australia/Lindeman',
    label: '(GMT+10) Australia/Lindeman',
  },
  {
    value: '(GMT+10) Pacific/Chuuk',
    label: '(GMT+10) Pacific/Chuuk',
  },
  {
    value: '(GMT+10) Pacific/Guam',
    label: '(GMT+10) Pacific/Guam',
  },
  {
    value: '(GMT+10) Pacific/Port Moresby',
    label: '(GMT+10) Pacific/Port Moresby',
  },
  {
    value: '(GMT+10) Pacific/Saipan',
    label: '(GMT+10) Pacific/Saipan',
  },
  {
    value: '(GMT+10.5) Australia/Adelaide',
    label: '(GMT+10.5) Australia/Adelaide',
  },
  {
    value: '(GMT+10.5) Australia/Broken Hill',
    label: '(GMT+10.5) Australia/Broken Hill',
  },
  {
    value: '(GMT+11) Antarctica/Macquarie',
    label: '(GMT+11) Antarctica/Macquarie',
  },
  {
    value: '(GMT+11) Asia/Magadan',
    label: '(GMT+11) Asia/Magadan',
  },
  {
    value: '(GMT+11) Asia/Sakhalin',
    label: '(GMT+11) Asia/Sakhalin',
  },
  {
    value: '(GMT+11) Asia/Srednekolymsk',
    label: '(GMT+11) Asia/Srednekolymsk',
  },
  {
    value: '(GMT+11) Australia/Hobart',
    label: '(GMT+11) Australia/Hobart',
  },
  {
    value: '(GMT+11) Australia/Lord Howe',
    label: '(GMT+11) Australia/Lord Howe',
  },
  {
    value: '(GMT+11) Australia/Melbourne',
    label: '(GMT+11) Australia/Melbourne',
  },
  {
    value: '(GMT+11) Australia/Sydney',
    label: '(GMT+11) Australia/Sydney',
  },
  {
    value: '(GMT+11) Pacific/Bougainville',
    label: '(GMT+11) Pacific/Bougainville',
  },
  {
    value: '(GMT+11) Pacific/Efate',
    label: '(GMT+11) Pacific/Efate',
  },
  {
    value: '(GMT+11) Pacific/Guadalcanal',
    label: '(GMT+11) Pacific/Guadalcanal',
  },
  {
    value: '(GMT+11) Pacific/Kosrae',
    label: '(GMT+11) Pacific/Kosrae',
  },
  {
    value: '(GMT+11) Pacific/Noumea',
    label: '(GMT+11) Pacific/Noumea',
  },
  {
    value: '(GMT+11) Pacific/Pohnpei',
    label: '(GMT+11) Pacific/Pohnpei',
  },
  {
    value: '(GMT+12) Asia/Anadyr',
    label: '(GMT+12) Asia/Anadyr',
  },
  {
    value: '(GMT+12) Asia/Kamchatka',
    label: '(GMT+12) Asia/Kamchatka',
  },
  {
    value: '(GMT+12) Pacific/Fiji',
    label: '(GMT+12) Pacific/Fiji',
  },
  {
    value: '(GMT+12) Pacific/Funafuti',
    label: '(GMT+12) Pacific/Funafuti',
  },
  {
    value: '(GMT+12) Pacific/Kwajalein',
    label: '(GMT+12) Pacific/Kwajalein',
  },
  {
    value: '(GMT+12) Pacific/Majuro',
    label: '(GMT+12) Pacific/Majuro',
  },
  {
    value: '(GMT+12) Pacific/Nauru',
    label: '(GMT+12) Pacific/Nauru',
  },
  {
    value: '(GMT+12) Pacific/Norfolk',
    label: '(GMT+12) Pacific/Norfolk',
  },
  {
    value: '(GMT+12) Pacific/Tarawa',
    label: '(GMT+12) Pacific/Tarawa',
  },
  {
    value: '(GMT+12) Pacific/Wake',
    label: '(GMT+12) Pacific/Wake',
  },
  {
    value: '(GMT+12) Pacific/Wallis',
    label: '(GMT+12) Pacific/Wallis',
  },
  {
    value: '(GMT+13) Antarctica/McMurdo',
    label: '(GMT+13) Antarctica/McMurdo',
  },
  {
    value: '(GMT+13) Pacific/Apia',
    label: '(GMT+13) Pacific/Apia',
  },
  {
    value: '(GMT+13) Pacific/Auckland',
    label: '(GMT+13) Pacific/Auckland',
  },
  {
    value: '(GMT+13) Pacific/Fakaofo',
    label: '(GMT+13) Pacific/Fakaofo',
  },
  {
    value: '(GMT+13) Pacific/Kanton',
    label: '(GMT+13) Pacific/Kanton',
  },
  {
    value: '(GMT+13) Pacific/Tongatapu',
    label: '(GMT+13) Pacific/Tongatapu',
  },
  {
    value: '(GMT+13.75) Pacific/Chatham',
    label: '(GMT+13.75) Pacific/Chatham',
  },
  {
    value: '(GMT+14) Pacific/Kiritimati',
    label: '(GMT+14) Pacific/Kiritimati',
  },
];

export const weekOptions = [
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
].map(it => ({
  value: it,
  label: it,
  children: Array.from({ length: 24 }, (_, index) => index).map($it => ({
    value: `${it} ${$it}:00:00`,
    label: `${$it}:00:00`,
  })),
}));
